import { Component, OnInit } from '@angular/core';
import { FormField, FormFieldOption } from "../../../../../dto/util/form-field";
import { TranslateService } from "@ngx-translate/core";
import { combineLatest } from "rxjs";
import { ListasService } from "../../../../../services/listas.service";
import { Constants } from "../../../../../constants/constants";
import { FormGroup } from "@angular/forms";
import { ListaValorDto } from "../../../../../dto/expediente/lista-valor.dto";
import { PersonaLoginDTO } from "../../../../../dto/util/persona.dto";
import { TramiteService } from "../../../../../services/tramite.service";
import { TramiteDTO } from "../../../models/tramiteDTO";
import { AlertaModalService } from "../../../../../services/util/alerta-modal.service";

@Component({
  selector: 'app-liq-judicial-tipo-solicitante',
  templateUrl: './liq-judicial-tipo-solicitante.component.html',
  styleUrl: './liq-judicial-tipo-solicitante.component.scss'
})
export class LiqJudicialTipoSolicitanteComponent implements OnInit {
  // Formulario
  campoTipoSolicitante: FormField[] = [];
  // Listas
  tipoSolicitante: FormFieldOption[] = [];
  listaTipoSolicitante: ListaValorDto[] = [];
  // Multilenguaje
  roiText: any = {};
  comunText: any = {};
  alertaText: any = {};
  // Boolean
  mostrarSociedad = false;
  mostrarPNC = false;
  mostrarPNNC = false;
  mostrarSucursal = false;
  // Datos del usuario en sesión
  dataUsuario!: PersonaLoginDTO | undefined;
  // String
  codigoTipoSolicitante!: string | undefined;
  nombreCompleto = '';
  constructor(
    private translate: TranslateService,
    private listaService: ListasService,
    private tramiteService: TramiteService,
    private alertaModalService: AlertaModalService,
  ) {
  }
  ngOnInit(): void {
    this.nombreCompleto = this.getStorageItem(Constants.NOMBRE_TRAMITE) || '';
    // Se obtienen los datos del usuario en la sesión
    this.dataUsuario = JSON.parse(
      sessionStorage.getItem(Constants.USER_INFORMATION_STORAGE)!
    );
    // Lista tipos de solicitante
    this.listarTipoSolicitante();
    combineLatest([
      this.translate.stream('tramites'),
      this.translate.stream('comun-label'),
      this.translate.stream('alertas'),
    ]).subscribe(([tramitesText, comunLabelText, alertaText]) => {
      // Procesar el texto de 'tramites'
      for (const key of Object.keys(tramitesText)) {
        this.roiText[key] = tramitesText[key];
      }

      // Procesar el texto de 'comun-label'
      for (const key of Object.keys(comunLabelText)) {
        this.comunText[key] = comunLabelText[key];
      }

      // Procesar el texto de 'alertas'
      for (const key of Object.keys(alertaText)) {
        this.alertaText[key] = alertaText[key];
      }
      this.initFormularioTipoSolicitante();
    });
    sessionStorage.removeItem('nuevoTramite');
    // Se valida si existe un trámite pendiente por completar
    this.tramiteService
      .consultarTramitePendiente(
        Number(this.dataUsuario?.idUsuario),
        Constants.ID_ENTIDAD_SSO_LJI
      )
      .subscribe(resp => {
        if ((resp as { Id: number }).Id !== null) {
          // Se consume el servicio que obtiene el detalle del trámite
          this.alertaModalService.confirmacion(
            this.alertaText['continuar-solicitud-almacenada'],
            '',
            () => {
              this.consultarTramitePorID(resp.Id);
              sessionStorage.setItem('nuevoTramite', 'false');
            },
            () => {
              sessionStorage.setItem('nuevoTramite', 'true');
            }
          );
        }
      });
  }

  // Se setean los datos en los formularios, en el caso de que exista un trámite pendiente
  consultarTramitePorID(id: number) {
    this.tramiteService
      .cargarTramitePendiente(id)
      .subscribe((resp: TramiteDTO) => {
        if (resp) {
          this.campoTipoSolicitante = this.campoTipoSolicitante.map((field) => {
            this.codigoTipoSolicitante = resp.tipoSolicitante.codigo;
            switch (field.name) {
              case 'tipoSolicitante':
                field.value = this.codigoTipoSolicitante ? this.codigoTipoSolicitante : undefined;
                break;
            }
            // Habilita el formulario de persona natural comerciante
            if (this.codigoTipoSolicitante == 'PNC') {
              this.mostrarPNC = true;
              this.mostrarPNNC = false;
              this.mostrarSociedad = false;
              this.mostrarSucursal = false;
            }

            // Habilita el formulario de persona natural no comerciante
            if (this.codigoTipoSolicitante == 'PNNC') {
              this.mostrarPNNC = true;
              this.mostrarPNC = false;
              this.mostrarSociedad = false;
              this.mostrarSucursal = false;
            }

            // Habilita el formulario de sociedad
            if (this.codigoTipoSolicitante == 'SOCIEDAD') {
              this.mostrarSociedad = true;
              this.mostrarPNC = false;
              this.mostrarPNNC = false;
              this.mostrarSucursal = false;
            }

            // Habilita el formulario de sucursal extranjera
            if (this.codigoTipoSolicitante == 'SUC_EXTRANJERA') {
              this.mostrarSucursal = true;
              this.mostrarPNC = false;
              this.mostrarPNNC = false;
              this.mostrarSociedad = false;
            }
            return field;
          });
        }
      });
  }
  // Se consume el servicio de listar tipo solicitante
  listarTipoSolicitante() {
    this.listaService.listaValor(Constants.ROI_TIPO_SOLICITANTE).subscribe(resp => {
      this.listaTipoSolicitante = resp;
      this.tipoSolicitante = resp.map(item => ({
        Id: item.Codigo ?? '',
        Nombre: item.Valor || '',
      }));
      this.initFormularioTipoSolicitante();
    });
  }
  // Se inicializa el formulario de tipo de solicitante
  initFormularioTipoSolicitante() {
    this.campoTipoSolicitante = [
      {
        name: 'tipoSolicitante',
        label: this.roiText['reorganizacion-ordinaria-insolvencia']['tipo_solicitante'],
        type: 'select',
        required: true,
        visible: true,
        width: '6',
        options: this.tipoSolicitante,
        errorMessages: {
          required: this.roiText['reorganizacion-ordinaria-insolvencia']['campo-required'],
        },
      },
    ]
  }

  validarTipo(event: { controlName?: string; controlValue: unknown; form: FormGroup; }) {
    if (event.controlName === 'tipoSolicitante') {
      // Se muestra alerta en caso de cambiar el tipo de solicitante y exista un trámite pendiente
      let tipo = (event.controlValue) as FormFieldOption;
      if (this.codigoTipoSolicitante !== undefined) {
        if (event.controlValue !== this.codigoTipoSolicitante) {
          this.alertaModalService.confirmacion(
            this.alertaText['roi']['cambio_tipo_solicitante'],
            this.alertaText['roi']['tipo_solicitante'],
            () => {
              // Habilita el formulario de persona natural comerciante
              if (tipo.Id == 'PNC') {
                this.mostrarPNC = true;
                this.mostrarPNNC = false;
                this.mostrarSociedad = false;
                this.mostrarSucursal = false;
              }

              // Habilita el formulario de persona natural no comerciante
              if (tipo.Id == 'PNNC') {
                this.mostrarPNNC = true;
                this.mostrarPNC = false;
                this.mostrarSociedad = false;
                this.mostrarSucursal = false;
              }

              // Habilita el formulario de sociedad
              if (tipo.Id == 'SOCIEDAD') {
                this.mostrarSociedad = true;
                this.mostrarPNC = false;
                this.mostrarPNNC = false;
                this.mostrarSucursal = false;
              }

              // Habilita el formulario de sucursal extranjera
              if (tipo.Id == 'SUC_EXTRANJERA') {
                this.mostrarSucursal = true;
                this.mostrarPNC = false;
                this.mostrarPNNC = false;
                this.mostrarSociedad = false;
              }
            },
            () => { });
        }
      } else {
        // Habilita el formulario de persona natural comerciante
        if (tipo.Id == 'PNC') {
          this.mostrarPNC = true;
          this.mostrarPNNC = false;
          this.mostrarSociedad = false;
          this.mostrarSucursal = false;
        }

        // Habilita el formulario de persona natural no comerciante
        if (tipo.Id == 'PNNC') {
          this.mostrarPNNC = true;
          this.mostrarPNC = false;
          this.mostrarSociedad = false;
          this.mostrarSucursal = false;
        }

        // Habilita el formulario de sociedad
        if (tipo.Id == 'SOCIEDAD') {
          this.mostrarSociedad = true;
          this.mostrarPNC = false;
          this.mostrarPNNC = false;
          this.mostrarSucursal = false;
        }

        // Habilita el formulario de sucursal extranjera
        if (tipo.Id == 'SUC_EXTRANJERA') {
          this.mostrarSucursal = true;
          this.mostrarPNC = false;
          this.mostrarPNNC = false;
          this.mostrarSociedad = false;
        }
      }
    }
  }

  getStorageItem(key: string): string | null {
    return sessionStorage.getItem(key) || localStorage.getItem(key);
  }
}
